'use strict';

function findParentForm(element) {
  var parentNode = element.parentNode;

  if (!parentNode || parentNode.nodeName === 'FORM') {
    return parentNode;
  }

  return findParentForm(parentNode);
}

module.exports = {
  findParentForm: findParentForm
};



//////////////////
// WEBPACK FOOTER
// ./~/braintree-web-drop-in/lib/find-parent-form.js
// module id = 786
// module chunks = 0